import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
} from '@mui/material';
import TerminalOrangeButton from '../ui/TerminalOrangeButton';
import { terminalSelectMenuProps, terminalSelectSx } from '../../theme/terminalStyles';
import { useListWarehousesQuery } from '../../store/api/stocktakeApi';

const WarehouseSelectDialog = ({ open, onClose, onConfirm, isSubmitting }) => {
  const { data: warehouses = [], isLoading } = useListWarehousesQuery(undefined, { skip: !open });
  const [warehouseId, setWarehouseId] = useState('');

  const handleClose = () => {
    setWarehouseId('');
    onClose();
  };

  const handleConfirm = () => {
    if (!warehouseId) return;
    onConfirm(Number(warehouseId));
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs">
      <DialogTitle>Оберіть склад</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Для локальної інвентаризації потрібно обрати склад.
        </Typography>
        {isLoading ? (
          <CircularProgress size={28} />
        ) : (
          <FormControl fullWidth size="small" sx={terminalSelectSx}>
            <InputLabel id="warehouse-select-label">Склад</InputLabel>
            <Select
              labelId="warehouse-select-label"
              label="Склад"
              value={warehouseId}
              onChange={(e) => setWarehouseId(e.target.value)}
              MenuProps={terminalSelectMenuProps}
            >
              {warehouses.map((wh) => (
                <MenuItem key={wh.id} value={wh.id}>
                  {wh.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 2, pb: 2 }}>
        <TerminalOrangeButton
          onClick={handleClose}
          sx={{ bgcolor: 'transparent', color: 'text.primary', boxShadow: 'none' }}
        >
          Скасувати
        </TerminalOrangeButton>
        <TerminalOrangeButton onClick={handleConfirm} disabled={!warehouseId || isSubmitting}>
          {isSubmitting ? <CircularProgress size={22} color="inherit" /> : 'Створити'}
        </TerminalOrangeButton>
      </DialogActions>
    </Dialog>
  );
};

export default WarehouseSelectDialog;
